// extracted by mini-css-extract-plugin
module.exports = {"content":"Regulation_content__2_bMy","calloutSection":"Regulation_calloutSection__kbMie"};